import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { StageService } from '../services/stage.service';
import { RailingGenerationService } from '../services/railing/services/railing-generation.service';

@Component({
  selector: 'app-edit-post-mounting',
  templateUrl: './edit-post-mounting.component.html',
  styleUrls: ['./edit-post-mounting.component.scss']
})
export class EditPostMountingComponent implements OnInit {
  @Output() step2Editer = new EventEmitter();

  surfaceBase: boolean = true;
  fasciaBracket: boolean = true;
  fascia: boolean = true;
  stanchion: boolean = true;
  inset: boolean = true;
  isPostCapsVisible: boolean;
  selectedRailingType = '';
  selectedMounting = {
    surfaceBase: false,
    fascia: false,
    fasciaBracket: false,
    stanchion: false,
    inset: false
  };

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }

  constructor(
    public dataForMenu: DataForDisplayingMenuItemsService,
    private railingGenerationService: RailingGenerationService
  ) {
    this.dataForMenu.postMounting.subscribe(mountingType => {
      this.setSelectedMounting(mountingType);
    });
  }

  ngOnInit() {
    this.dataForMenu.postCapsVisible.subscribe((visible: boolean) => {
      this.isPostCapsVisible = visible;

      this.railingGenerationService.setPostCapsVisibility(visible);
    });

    this.dataForMenu.railingType.subscribe(railingType => {
      this.selectedRailingType = railingType;
      switch (railingType) {
        case 'DesignRail': {
          this.surfaceBase = true;
          this.fascia = true;
          this.fasciaBracket = true;
          this.stanchion = true;
          this.inset = false;
          break;
        }
        case 'Wood': {
          this.surfaceBase = false;
          this.fascia = true;
          this.fasciaBracket = false;
          this.stanchion = false;
          this.inset = true;
          break;
        }
        case 'Composite': {
          this.surfaceBase = false;
          this.fascia = false;
          this.fasciaBracket = false;
          this.stanchion = false;
          this.inset = true;
          break;
        }
        case 'Steel flat bar': {
          this.surfaceBase = true;
          this.fascia = true;
          this.fasciaBracket = false;
          this.stanchion = false;
          this.inset = false;
          break;
        }
        case 'Steel round tubular': {
          this.surfaceBase = true;
          this.fascia = true;
          this.fasciaBracket = false;
          this.stanchion = false;
          this.inset = false;
          break;
        }
        case 'Modern': {
          // "Base Mount only" (spec p.2 rule 3)
          this.surfaceBase = true;
          this.fascia = false;
          this.fasciaBracket = false;
          this.stanchion = false;
          this.inset = false;
          break;
        }
        default: {
          this.inset = false;
        }
      }
    });
  }

  get showBaseCapBlock(): boolean {
    return this.selectedRailingType === 'DesignRail' && this.selectedMounting.surfaceBase === true;
  }

  setPostMounting(value: string) {
    this.dataForMenu.setPostMounting(value);
  }

  setCapsVisibility() {
    this.dataForMenu.postCapsVisible.next(this.isPostCapsVisible);
    this.dataForMenu.setRailOptions('basePlateCovers', this.isPostCapsVisible);
  }

  setSelectedMounting(value) {
    switch (value) {
      case 'Base Mount': {
        this.clearSelection();
        this.selectedMounting.surfaceBase = true;
        break;
      }
      case 'Fascia Bracket Mount': {
        this.clearSelection();
        this.selectedMounting.fasciaBracket = true;
        break;
      }
      case 'Fascia Mount': {
        this.clearSelection();
        this.selectedMounting.fascia = true;
        break;
      }
      case 'Stantion Mount': {
        this.clearSelection();
        this.selectedMounting.stanchion = true;
        break;
      }
      case 'Core Mount': {
        this.clearSelection();
        this.selectedMounting.inset = true;
        break;
      }
    }
  }

  clearSelection() {
    this.selectedMounting = {
      surfaceBase: false,
      fascia: false,
      fasciaBracket: false,
      stanchion: false,
      inset: false
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/edit-post-mounting/edit-post-mounting.component.ts